// extracted by mini-css-extract-plugin
export default {"totals":"css-kzoTGmA3u0","totals_row":"css-l6sb4SlQD7"};